window.addEventListener("load", function () {
  $(".floatright__close").on("click", function () {
    $("#ovensmash-floatright").toggleClass("active");
    $(this).toggleClass("active");
  });
});
